var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.search,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "top" },
        [
          _c(
            "div",
            { staticClass: "topItems" },
            [
              _c("p", { staticClass: "topItemsTit" }, [_vm._v("课程类型")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "topInput",
                  attrs: { clearable: "", placeholder: "请选择课程类型" },
                  on: { change: _vm.changeType },
                  model: {
                    value: _vm.declareType,
                    callback: function ($$v) {
                      _vm.declareType = $$v
                    },
                    expression: "declareType",
                  },
                },
                _vm._l(_vm.declareOption, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.userInfo.roleType == 3
            ? _c(
                "el-button",
                {
                  staticClass: "res",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addCourse()
                    },
                  },
                },
                [_vm._v("添加课程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tables" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                stripe: "",
                data: _vm.listData,
                "tooltip-effect": "dark",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "序号",
                  width: "120",
                  type: "index",
                },
              }),
              _vm._v(" "),
              _vm.userInfo.roleType == 1 || _vm.userInfo.roleType == 2
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "schoolName",
                      label: "学校名称",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "courseName",
                  label: "课程名称",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "courseLeader",
                  label: "课程负责人",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "省推荐状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state < 6
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("未推荐"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 6
                          ? _c("span", { staticClass: "countGreen" }, [
                              _vm._v("未退回"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 7
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("已退回"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 8
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("已通过"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "市教育局推荐状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.schoolType == 1 && scope.row.state < 5
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("未推荐"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.schoolType == 1 && scope.row.state == 5
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("已退回"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.schoolType == 1 && scope.row.state > 5
                          ? _c("span", { staticClass: "countGreen" }, [
                              _vm._v("已推荐"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.schoolType == 2
                          ? _c("span", [_vm._v("--")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "学校推荐状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state < 3
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("未推荐"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 3
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("已退回"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state > 3
                          ? _c("span", { staticClass: "countGreen" }, [
                              _vm._v("已推荐"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "申报书提交状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state == 0
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("未填写"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 1
                          ? _c("span", { staticClass: "countGreen" }, [
                              _vm._v("已保存"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state > 1 && scope.row.state != 3
                          ? _c("span", { staticClass: "countGreen" }, [
                              _vm._v("已提交"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.state == 3
                          ? _c("span", { staticClass: "countRed" }, [
                              _vm._v("被退回"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "address",
                  label: "操作",
                  width: "230",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-row", [
                          scope.row.state > 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getDetail(scope.row, 0)
                                    },
                                  },
                                },
                                [_vm._v("预览")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.state >= 6
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getDetail(scope.row, 1)
                                    },
                                  },
                                },
                                [_vm._v("下载PDF")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 5 && scope.row.state == 0
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.fillIn(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("填写申报书")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 5 && scope.row.state == 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.fillIn(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("修改申报书")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 5 && scope.row.state == 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sub(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("提交")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 5 && scope.row.state == 3
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.fillIn(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("修改申报书")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 5 && scope.row.state == 3
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sub(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("重新提交")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 3 && scope.row.state == 2
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 1)
                                    },
                                  },
                                },
                                [_vm._v("推荐")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 3 && scope.row.state == 2
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 3 && scope.row.state == 5
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 3 &&
                          scope.row.schoolType == 2 &&
                          scope.row.state == 7
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 2 &&
                          scope.row.schoolType == 1 &&
                          scope.row.state == 4
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 1)
                                    },
                                  },
                                },
                                [_vm._v("推荐")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 2 &&
                          scope.row.schoolType == 1 &&
                          scope.row.state == 4
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 2 &&
                          scope.row.schoolType == 1 &&
                          scope.row.state == 7
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userInfo.roleType == 1 && scope.row.state == 6
                            ? _c(
                                "span",
                                {
                                  staticClass: "caozuo",
                                  on: {
                                    click: function ($event) {
                                      return _vm.subReview(scope.row.id, 0)
                                    },
                                  },
                                },
                                [_vm._v("退回")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _vm.isDown
        ? _c("div", { staticClass: "zhezhao" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { title: "添加课程", visible: _vm.dialog },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
            close: function ($event) {
              return _vm.close()
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "170px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { staticClass: "marRight20" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "课程类别" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            placeholder: "请选择课程类别",
                          },
                          model: {
                            value: _vm.addDeclareType,
                            callback: function ($$v) {
                              _vm.addDeclareType = $$v
                            },
                            expression: "addDeclareType",
                          },
                        },
                        _vm._l(_vm.declareOption, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "课程名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入课程名称" },
                        model: {
                          value: _vm.form.courseName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "courseName", $$v)
                          },
                          expression: "form.courseName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "课程负责人" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            placeholder: "请选择课程负责人",
                          },
                          model: {
                            value: _vm.form.courseLeader,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "courseLeader", $$v)
                            },
                            expression: "form.courseLeader",
                          },
                        },
                        _vm._l(_vm.teacherAll, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.courseLeader, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "resBtn",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submit("form")
                },
              },
            },
            [_vm._v("添加课程")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tan" },
        [
          _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: { title: "", visible: _vm.dialog2 },
              on: {
                "update:visible": function ($event) {
                  _vm.dialog2 = $event
                },
                close: function ($event) {
                  return _vm.closePDF()
                },
              },
            },
            [
              _vm.showDown && _vm.isDownBtn
                ? _c(
                    "div",
                    { staticClass: "downPDF", on: { click: _vm.downPDF2 } },
                    [_vm._v("下载PDF")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "vue-html2pdf",
                {
                  ref: "html2Pdf",
                  attrs: {
                    "show-layout": _vm.showLayout,
                    "float-layout": true,
                    "enable-download": true,
                    "preview-modal": true,
                    "paginate-elements-by-height": 1400,
                    filename: "我是pdf",
                    "pdf-quality": 2,
                    "manual-pagination": false,
                    "pdf-format": "a4",
                    "pdf-orientation": "landscape",
                    "pdf-content-width": "800px",
                    "html-to-pdf-options": _vm.htmlToPdfOptions,
                  },
                  on: {
                    hasStartedGeneration: function ($event) {
                      return _vm.hasStartedGeneration()
                    },
                    hasGenerated: function ($event) {
                      return _vm.hasGenerated($event)
                    },
                  },
                },
                [
                  _c(
                    "section",
                    { attrs: { slot: "pdf-content" }, slot: "pdf-content" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { padding: "80px", color: "#000000" },
                          attrs: { id: "dao2" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "one",
                              staticStyle: { position: "relative" },
                            },
                            [
                              _vm.isDown
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "shuiyin",
                                      staticStyle: {
                                        width: "800px",
                                        height: "1350px",
                                        position: "absolute",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/shuiyin.png"),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "topfj",
                                  staticStyle: {
                                    "font-size": "24px",
                                    "font-family": "'宋体'",
                                  },
                                },
                                [_vm._v("附件2")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "title",
                                  staticStyle: {
                                    "text-align": "center",
                                    "font-size": "32px",
                                    "line-height": "42px",
                                    "margin-top": "100px",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v("江苏省职业教育精品在线开放课程"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [_vm._v("验收认定申报书")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "feng",
                                  staticStyle: {
                                    "font-size": "24px",
                                    "line-height": "45px",
                                    "margin-top": "200px",
                                    "margin-left": "200px",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      "课程名称：" +
                                        _vm._s(_vm.secondDetail.courseName)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "课程负责人：" +
                                        _vm._s(_vm.secondDetail.courseLeader)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "联系电话：" +
                                        _vm._s(_vm.secondDetail.contactNumber)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "主要开课平台：" +
                                        _vm._s(
                                          _vm.secondDetail.mainClassPlatform
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "认定课程学校：" +
                                        _vm._s(_vm.secondDetail.courseSchool)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "专业类代码：" +
                                        _vm._s(
                                          _vm.secondDetail.professionalCode
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "填表日期：" +
                                        _vm._s(_vm.secondDetail.declarationDate)
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fengBottom",
                                  staticStyle: {
                                    "font-size": "22px",
                                    "line-height": "32px",
                                    "text-align": "center",
                                    "margin-top": "400px",
                                    "margin-bottom": "100px",
                                  },
                                },
                                [
                                  _c("div", [_vm._v("江苏省教育厅制")]),
                                  _vm._v(" "),
                                  _c("div", [_vm._v("二○二二年四月")]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "two",
                              staticStyle: {
                                position: "relative",
                                "padding-top": "100px",
                                "padding-bottom": "800px",
                              },
                            },
                            [
                              _vm.isDown
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "shuiyin",
                                      staticStyle: {
                                        width: "800px",
                                        height: "1350px",
                                        position: "absolute",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/shuiyin.png"),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "tit",
                                  staticStyle: {
                                    "text-indent": "40px",
                                    "margin-top": "30px",
                                  },
                                },
                                [_vm._v("填表说明")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-family": "'仿宋'",
                                    "font-size": "26px",
                                    "line-height": "40px",
                                    "text-indent": "44px",
                                    "letter-spacing": "4px",
                                    "margin-bottom": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "1.开课平台是指提供面向职业院校和社会开放学习服务的公开课程平台。"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-family": "'仿宋'",
                                    "font-size": "26px",
                                    "line-height": "40px",
                                    "text-indent": "44px",
                                    "letter-spacing": "4px",
                                    "margin-bottom": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "2.在多个平台开设的课程可以选择大规模在线开放课程特征明显、课程团队在线教学服务好、在线教学效果好的一个主要平台申报。"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-family": "'仿宋'",
                                    "font-size": "26px",
                                    "line-height": "40px",
                                    "text-indent": "44px",
                                    "letter-spacing": "4px",
                                    "margin-bottom": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "3.专业类代码指《职业教育专业目录（2021年）》中的专业类代码（四位数字）。公共基础课程填“9999”。"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-family": "'仿宋'",
                                    "font-size": "26px",
                                    "line-height": "40px",
                                    "text-indent": "44px",
                                    "letter-spacing": "4px",
                                    "margin-bottom": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "4.申报书与附件材料一并按每门课程单独装订成册，一式两份。"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "three" }, [
                            _c("div", { class: { eachPage: _vm.isDown } }, [
                              _vm.isDown
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "shuiyin",
                                      staticStyle: {
                                        width: "800px",
                                        height: "1350px",
                                        position: "absolute",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/img/shuiyin.png"),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "comTit tit",
                                  staticStyle: {
                                    "font-size": "20px",
                                    "font-family": "'黑体'",
                                    "text-indent": "40px",
                                    "margin-top": "30px",
                                  },
                                },
                                [_vm._v("一、课程基本情况")]
                              ),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticStyle: {
                                    width: "800px",
                                    "border-collapse": "collapse",
                                    border: "1px solid #323232",
                                    "text-align": "center",
                                    margin: "10px auto",
                                    cursor: "pointer",
                                  },
                                  attrs: { border: "1" },
                                },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程名称")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseName)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程立项项目序号")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail.courseProjectNo
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程负责人")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseLeader)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("负责人所在单位")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.secondDetail.unit))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程对象")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseObject)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程性质")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseNature)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程类型")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseType)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程讲授语言")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail
                                              .courseTeachingLanguage
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("开放程度")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail.degreeOpenness
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("主要开课平台")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail.mainClassPlatform
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("平台首页网址")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.secondDetail.website))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v("首期上线平台"),
                                        _c("br"),
                                        _vm._v("及时间"),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail.onlinePlatformTime
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程开设期次")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.secondDetail.courseDuration
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit titTable",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'黑体'",
                                          width: "25%",
                                          "line-height": "30px",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [_vm._v("课程链接")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text",
                                        staticStyle: {
                                          "font-size": "20px",
                                          "font-family": "'宋体'",
                                          width: "75%",
                                          "text-align": "left",
                                          "padding-left": "15px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.secondDetail.courseLink)
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "comTit tit",
                                  staticStyle: {
                                    "font-size": "20px",
                                    "font-family": "'黑体'",
                                    "text-indent": "40px",
                                    "margin-top": "30px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "若因同一门课程课时较长，分段在线开设，请填写下表："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticStyle: {
                                    width: "800px",
                                    "border-collapse": "collapse",
                                    border: "1px solid #323232",
                                    "text-align": "center",
                                    margin: "10px auto",
                                    cursor: "pointer",
                                  },
                                  attrs: { border: "1" },
                                },
                                [
                                  _c("tr", [
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("序号"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("课程名称"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("负责人"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("负责人单位"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("课时（周）"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("课程链接"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.secondDetail.courseHourList,
                                    function (i, index) {
                                      return _vm.secondDetail.courseHourList
                                        .length > 0
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "comTit" },
                                              [_vm._v(_vm._s(index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.courseName
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.responsiblePerson
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.responsibleUnit
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.classHours
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.courseLink
                                                ),
                                              },
                                            }),
                                          ])
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.secondDetail.courseHourList.length == 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "line-height": "50px",
                                            },
                                            attrs: { colspan: "6" },
                                          },
                                          [_vm._v("无")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("二、课程团队情况"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "table",
                                { attrs: { border: "1" } },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit",
                                        attrs: { colspan: "8" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      课程团队主要成员（含负责人，限5人之内）\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("序号"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("姓名"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("单位"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("职称"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("手机号码"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("电子邮箱"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("承担任务"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("平台用户名"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.secondDetail.courseTeamList,
                                    function (i, index) {
                                      return _vm.secondDetail.courseTeamList
                                        .length > 0
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "comTit" },
                                              [_vm._v(_vm._s(index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.name),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.unit),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.jobTitle),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.mobile),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.email),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.undertakeTasks
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.platformUserName
                                                ),
                                              },
                                            }),
                                          ])
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.secondDetail.courseTeamList.length == 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "line-height": "50px",
                                            },
                                            attrs: { colspan: "8" },
                                          },
                                          [_vm._v("无")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass: "singleTable",
                                  attrs: { border: "1" },
                                },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comTit",
                                        attrs: { colspan: "8" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      课程团队其他成员\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("序号"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("姓名"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("单位"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("职称"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("承担任务"),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "comTit" }, [
                                      _vm._v("平台用户名"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.secondDetail.courseTeamOtherList,
                                    function (i, index) {
                                      return _vm.secondDetail
                                        .courseTeamOtherList.length > 0
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { staticClass: "comTit" },
                                              [_vm._v(_vm._s(index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.name),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.unit),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(i.jobTitle),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.undertakeTasks
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  i.platformUserName
                                                ),
                                              },
                                            }),
                                          ])
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.secondDetail.courseTeamOtherList.length ==
                                  0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "line-height": "50px",
                                            },
                                            attrs: { colspan: "6" },
                                          },
                                          [_vm._v("无")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { class: { eachPage: _vm.isDown } }, [
                              _vm.isDown
                                ? _c("div", { staticClass: "shuiyin" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/shuiyin.png"),
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass: "singleTable",
                                  attrs: { border: "1" },
                                },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticClass: "comTit titTable" },
                                      [
                                        _vm._v(
                                          "\n                      课程负责人教学情况"
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "comText text" },
                                          [_vm._v("（不超过500字）")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "comText text textarea",
                                        attrs: { valign: "top" },
                                      },
                                      [
                                        _c("p", { staticClass: "tips" }, [
                                          _vm._v(
                                            "（近5年来在承担学校教学任务、开展教学研究、获得教学奖励方面的情况）"
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.secondDetail.teachingSituation
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("三、课程简介及课程特色"),
                                _c("span", { staticClass: "comText text" }, [
                                  _vm._v("（不超过800字）"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("table", { attrs: { border: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "comText text textarea2",
                                      attrs: { valign: "top" },
                                    },
                                    [
                                      _c("p", { staticClass: "tips" }, [
                                        _vm._v(
                                          "（课程主要内容及面向对象，本课程运用信息技术在课程体系、教学内容和教学方法等方面的改革情况）"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.secondDetail.courseIntroduction
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("四、课程考核（试）情况"),
                                _c("span", { staticClass: "comText text" }, [
                                  _vm._v("（不超过500字）"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("table", { attrs: { border: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "comText text textarea",
                                      attrs: { valign: "top" },
                                    },
                                    [
                                      _c("p", { staticClass: "tips" }, [
                                        _vm._v(
                                          "[对学习者学习的考核（试）办法，成绩评定方式等。]"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.secondDetail.courseAssessment
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { class: { eachPage: _vm.isDown } }, [
                              _vm.isDown
                                ? _c("div", { staticClass: "shuiyin" }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../assets/img/shuiyin.png"),
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("五、课程应用情况"),
                                _c("span", { staticClass: "comText text" }, [
                                  _vm._v("（不超过800字）"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("table", { attrs: { border: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "comText text textarea2",
                                      attrs: { valign: "top" },
                                    },
                                    [
                                      _c("p", { staticClass: "tips" }, [
                                        _vm._v(
                                          "（在申报高校教学中的应用情况；面向其他职业院校学生和社会学习者应用情况及效果，其中包括使用课程学校总数、选课总人数、使用课程学校名称等）"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.secondDetail.courseApplication
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("六、课程建设计划"),
                                _c("span", { staticClass: "comText text" }, [
                                  _vm._v("（不超过500字）"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("table", { attrs: { border: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "comText text textarea",
                                      attrs: { valign: "top" },
                                    },
                                    [
                                      _c("p", { staticClass: "tips" }, [
                                        _vm._v(
                                          "（今后五年继续面向高校和社会开放学习服务计划，包括面向高校的教学应用计划和面向社会开设期次、持续更新和提供教学服务设想等）"
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.secondDetail
                                              .curriculumConstructionPlan
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comTit tit" }, [
                                _vm._v("七、课程负责人诚信承诺"),
                              ]),
                              _vm._v(" "),
                              _c("table", { attrs: { border: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "comText text textarea3",
                                      attrs: { valign: "top" },
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "本人已认真填写并检查以上材料，保证内容真实有效。"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "tips2" }, [
                                        _vm._v("课程负责人（签字）："),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "tips3" }, [
                                        _vm._v("年"),
                                        _c("span", [_vm._v("月")]),
                                        _vm._v("日"),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.isDown
                              ? _c("div", { staticClass: "shuiyin" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/shuiyin.png"),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "comTit tit" }, [
                              _vm._v("八、附件材料清单"),
                            ]),
                            _vm._v(" "),
                            _c("table", { attrs: { border: "1" } }, [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "comText text",
                                    attrs: { valign: "top" },
                                  },
                                  [
                                    _c("div", { staticClass: "comTit tit" }, [
                                      _vm._v("1.政治审查意见"),
                                      _c(
                                        "span",
                                        { staticClass: "comText text" },
                                        [_vm._v("（必须提供）")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "（本校党委对本校课程团队成员情况进行审查，以及对课程政治导向把关审查情况，确保课程正确的政治方向、价值取向。团队涉及多校时需要各校分别出具。须由学校党委盖章。无统一格式要求。）"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "fjUrl" }, [
                                      _vm._v("附件材料:"),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://file.icve.com.cn/file_doc/64/240/1023C36D45EA0BE7269A4D1095024C8A.doc",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "https://file.icve.com.cn/file_doc/64/240/1023C36D45EA0BE7269A4D1095024C8A.doc"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "comTit tit" }, [
                                      _vm._v("2.学术性评价意见"),
                                      _c(
                                        "span",
                                        { staticClass: "comText text" },
                                        [_vm._v("（必须提供）")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                      [学术评价意见由学校学术性组织（校教指委或学术委员会等），或相关部门组织的相应学科专业领域专家（不少于3名）组成的学术审查小组，经一定程序评价后出具。须由学术性组织盖章或学术审查小组全部专家签字。无统一格式要求。]\n                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "comTit tit" }, [
                                      _vm._v("3.课程数据信息表"),
                                      _c(
                                        "span",
                                        { staticClass: "comText text" },
                                        [_vm._v("（必须提供）")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("（须课程平台单位盖章）")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "comTit tit" }, [
                                      _vm._v("4.校外评价意见"),
                                      _c(
                                        "span",
                                        { staticClass: "comText text" },
                                        [_vm._v("（可选提供）")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                      [此评价意见作为课程有关学术水平、课程质量、应用效果等某一方面的佐证性材料或补充材料，可由教育部及省教指委等专家组织，有关学术组织、课程联盟组织、课程平台、课程应用高校（或高校相应院系）等出具，也可由相应学科专业领域的校外专家学者出具。须相关单位盖章或专家签字。评价意见以1份为宜，不得超过２份。无统一格式要求。]\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: { title: "", visible: _vm.dialog3 },
              on: {
                "update:visible": function ($event) {
                  _vm.dialog3 = $event
                },
                close: function ($event) {
                  return _vm.closePDF()
                },
              },
            },
            [
              _vm.showDown && _vm.isDownBtn
                ? _c(
                    "div",
                    { staticClass: "downPDF", on: { click: _vm.downPDF3 } },
                    [_vm._v("下载PDF")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "dao3", attrs: { id: "dao3" } }, [
                _c("div", { staticClass: "one" }, [
                  _vm.isDown
                    ? _c("div", { staticClass: "shuiyin" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/img/shuiyin.png"),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "topfj",
                      on: {
                        click: function ($event) {
                          return _vm.exportPdfHandler("dao3", "文件名称")
                        },
                      },
                    },
                    [_vm._v("附件3")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _c("div", [_vm._v("江苏省职业教育精品在线开放课程")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("立项建设申报书")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "feng",
                      staticStyle: { "font-family": "'宋体'" },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          "申报单位：" + _vm._s(_vm.thirdDetail.declarationUnit)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "课程名称：" + _vm._s(_vm.thirdDetail.courseName)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "课程类型：" + _vm._s(_vm.thirdDetail.courseType)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "立项类别：" + _vm._s(_vm.thirdDetail.projectCategory)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "专业类代码：" +
                            _vm._s(_vm.thirdDetail.professionalCode)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v("课程负责人：" + _vm._s(_vm.thirdDetail.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "申报日期：" + _vm._s(_vm.thirdDetail.declarationDate)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fengBottom" }, [
                    _c("div", [_vm._v("江苏省教育厅 制")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("2022年4月")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "two" }, [
                  _vm.isDown
                    ? _c("div", { staticClass: "shuiyin" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/img/shuiyin.png"),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tit3" }, [_vm._v("填 写 要 求")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "一、本表用A4纸张双面打印填报，本表封面之上不得另加其他封面。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "二、本表填写内容必须属实，所在学校应严格审核，对所填内容的真实性负责。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "三、表格文本中外文名词第一次出现时，要写清全称和缩写，再次出现时可以使用缩写。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "四、专业类代码指《职业教育专业目录（2021年）》中的专业类代码（四位数字）。公共基础课程填“9999”。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("五、如表格篇幅不够，可另附纸。")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "three" }, [
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("1．课程负责人情况"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { attrs: { border: "1" } },
                      [
                        _c("tr", { staticClass: "itemText" }, [
                          _c(
                            "td",
                            {
                              staticClass: "itemTit",
                              staticStyle: { "padding-left": "0" },
                              attrs: { rowspan: "6" },
                            },
                            [_vm._v("基本情况")]
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v("姓 名")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v("性　别")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.sex))]),
                          _vm._v(" "),
                          _c("td", [_vm._v("出生年月")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.birthday))]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("最终学历")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.education))]),
                          _vm._v(" "),
                          _c("td", [_vm._v("专业技术职务")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.technicalPosition)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("学　位")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.thirdDetail.academicDegree)),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("行政职务")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(
                              _vm._s(_vm.thirdDetail.administrativePosition)
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("所在院系")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "5" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.department)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("手 机")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.mobile))]),
                          _vm._v(" "),
                          _c("td", [_vm._v("电子邮件")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.email)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("通信地址(邮编)")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "5" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.address)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemTextMin" }, [
                          _c(
                            "td",
                            {
                              staticClass: "itemTit",
                              staticStyle: { "padding-left": "0" },
                              attrs: { rowspan: _vm.teachingList },
                            },
                            [_vm._v("教学情况")]
                          ),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c("div", { staticClass: "tipBox tipBox0" }, [
                              _c("div", [
                                _c("span", { staticClass: "tipsTit" }, [
                                  _vm._v("授课情况:"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "tipsText" }, [
                                  _vm._v(
                                    "现课程负责人近三年讲授本课程情况；近五年来讲授的主要课程（含课程名称、课程类别、周学时；届数及学生总人数）（不超过五门）。"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.teachingSituation) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemTextTable" }, [
                          _c(
                            "td",
                            { staticClass: "tipsTit", attrs: { colspan: "2" } },
                            [
                              _vm._v("近五年来讲授的"),
                              _c("br"),
                              _vm._v("主要课程名称"),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "tipsTit" }, [
                            _vm._v("课程类型"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "tipsTit" }, [
                            _vm._v("周学时"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "tipsTit" }, [
                            _vm._v("届数"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "tipsTit" }, [
                            _vm._v("学生总人数"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.thirdDetail.courseLeaderTeachingList,
                          function (i) {
                            return _vm.thirdDetail.courseLeaderTeachingList
                              .length > 0
                              ? _c("tr", { staticClass: "itemCourse" }, [
                                  _c("td", {
                                    attrs: { colspan: "2" },
                                    domProps: {
                                      textContent: _vm._s(i.courseName),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(i.courseType),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(i.classHour),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(i.sessionNumber),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(i.studentNumber),
                                    },
                                  }),
                                ])
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _vm.thirdDetail.courseLeaderTeachingList.length == 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: { "line-height": "50px" },
                                  attrs: { colspan: "6" },
                                },
                                [_vm._v("无")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemTextMin" }, [
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c("div", { staticClass: "tipBox tipBox0" }, [
                              _c("div", [
                                _c("span", { staticClass: "tipsTit" }, [
                                  _vm._v("教学研究情况："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "tipsText" }, [
                                  _vm._v(
                                    "承担的实践性教学任务（含实验、实习、课程设计、毕业设计/论文，学生总人数）。 "
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.teachingResearch) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemTextMin" }, [
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c("div", { staticClass: "tipBox tipBox0" }, [
                              _c("div", [
                                _c("span", { staticClass: "tipsTit" }, [
                                  _vm._v("学术研究情况："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "tipsText" }, [
                                  _vm._v(
                                    "主持的教学研究课题（含课题名称、来源、年限）（不超过五项）；作为第一署名人在国内外公开发行的刊物上发表的教学研究论文（含题目、刊物名称、时间）（不超过五项）；获得的教学表彰/奖励（不超过五项）；主编的省部级及以上规划教材、获奖教材（不超过五项）：\n                      "
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.teachingResearch) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("2．课程团队"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { attrs: { border: "1" } },
                      [
                        _c("tr", { staticClass: "itemCourse" }, [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "10%",
                                padding: "10px",
                                "line-height": "24px",
                              },
                              attrs: { rowspan: _vm.teamList },
                            },
                            [
                              _vm._v(
                                "其他人员构成（含辅导教师、教学设计、技术、支持服务等）\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "10%" } }, [
                            _vm._v("姓名"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "10%" } }, [
                            _vm._v("性别"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "10%" } }, [
                            _vm._v("出生年月"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "10%" } }, [
                            _vm._v("专业技术职务"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "15%" } }, [
                            _vm._v("学科专业"),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { width: "20%" } }, [
                            _vm._v("在本课程中承担的工作"),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("备注"),
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [_vm._v("(如联合申报请在本栏目中注明所在高校)")]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.thirdDetail.courseTeamList, function (i) {
                          return _vm.thirdDetail.courseTeamList.length > 0
                            ? _c("tr", { staticClass: "itemCourse" }, [
                                _c("td", {
                                  domProps: { textContent: _vm._s(i.name) },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: { textContent: _vm._s(i.sex) },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: { textContent: _vm._s(i.birthday) },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    textContent: _vm._s(i.technicalPosition),
                                  },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: { textContent: _vm._s(i.major) },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    textContent: _vm._s(i.jobContent),
                                  },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: { textContent: _vm._s(i.remarks) },
                                }),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm._l(5, function (i) {
                          return _vm.thirdDetail.courseTeamList.length < 5
                            ? _c("tr", { staticClass: "itemCourse" }, [
                                _c("td", { staticStyle: { color: "#FFf" } }, [
                                  _vm._v("."),
                                ]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td"),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemTextMin" }, [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "10%",
                                padding: "10px",
                                "line-height": "24px",
                              },
                            },
                            [_vm._v("队伍整体结构")]
                          ),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "7" } }, [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", { staticClass: "tipsTit" }, [
                                _vm._v(
                                  "教学、辅导、设计、技术等人员的配置情况"
                                ),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.teamStructure) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("3.课程情况"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("3-1 课程概况"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { attrs: { border: "1" } },
                      [
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("课程名称")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "5" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.courseName)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "itemText" }, [
                          _c("td", [_vm._v("预计总学时")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(_vm._s(_vm.thirdDetail.totalHour)),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v("预计总时长")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.thirdDetail.totalTime))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tr",
                          {
                            staticClass: "itemText",
                            staticStyle: { "text-align": "center" },
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "itemTit",
                                staticStyle: { "padding-left": "0" },
                                attrs: { rowspan: _vm.num },
                              },
                              [_vm._v("每讲情况")]
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v("序号")]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: { width: "30%" },
                                attrs: { colspan: "2" },
                              },
                              [_vm._v("专题标题")]
                            ),
                            _vm._v(" "),
                            _c("td", { staticStyle: { width: "15%" } }, [
                              _vm._v("时长"),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v("主讲教师")]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.thirdDetail.courseEachLectureList,
                          function (i, index) {
                            return _vm.thirdDetail.courseEachLectureList
                              .length > 0
                              ? _c(
                                  "tr",
                                  {
                                    staticClass: "itemText",
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(index + 1))]),
                                    _vm._v(" "),
                                    _c("td", {
                                      attrs: { colspan: "2" },
                                      domProps: {
                                        textContent: _vm._s(i.title),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(i.duration),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(i.lecturer),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _vm._l(5, function (i) {
                          return _vm.thirdDetail.courseEachLectureList.length <
                            5
                            ? _c(
                                "tr",
                                {
                                  staticClass: "itemText",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _c("td", { staticStyle: { color: "#FFf" } }, [
                                    _vm._v("."),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "2" } }),
                                  _vm._v(" "),
                                  _c("td"),
                                  _vm._v(" "),
                                  _c("td"),
                                ]
                              )
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("3-2课程描述"),
                    ]),
                    _vm._v(" "),
                    _c("table", { attrs: { border: "1" } }, [
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "3-1课程建设基础（目前本课程的开设情况，开设时间、年限、授课对象、授课人数，以及相关视频情况和面向社会的开放情况）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.thirdDetail.constructionFoundation
                                  ) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "3-2课程内容（课程完整教学内容简介、章节安排、学时分配、重点和难点、考核方式等）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.courseContent) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v("3-3课程预期受众的定位与目标"),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.positioningTarget) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", [
                                _c("span", [_vm._v("3-4相关教学资源储备情况")]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.resourceReserve) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("4.课程评价"),
                    ]),
                    _vm._v(" "),
                    _c("table", { attrs: { border: "1" } }, [
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox tipBox4" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "4-1 自我评价（本课程的主要特色介绍、影响力分析，国内外同类课程比较）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.selfEvaluation) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox tipBox4" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "4-2 学生评价（如果本课程已经面向学生开设，填写学生的评价意见，如未开设可不用填写）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.studentEvaluation) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox tipBox4" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "4-3 社会评价（如果本课程已经全部或部分向社会开放，请填写有关人员的评价，如未开放可不用填写）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.socialEvaluation) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { class: { eachPage: _vm.isDown } }, [
                    _vm.isDown
                      ? _c("div", { staticClass: "shuiyin" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../assets/img/shuiyin.png"),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("5．建设措施"),
                    ]),
                    _vm._v(" "),
                    _c("table", { attrs: { border: "1" } }, [
                      _c(
                        "tr",
                        {
                          staticClass: "itemText",
                          staticStyle: { "line-height": "20px" },
                        },
                        [
                          _c("td", [
                            _c("div", { staticClass: "tipBox" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "（包括后续建设与维护计划及措施、预期效果、经费预算等）"
                                  ),
                                ]),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.thirdDetail.constructionMeasures) +
                                  "\n                  "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("6．课程负责人诚信承诺"),
                    ]),
                    _vm._v(" "),
                    _c("table", { attrs: { border: "1" } }, [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "comText text textarea3",
                            attrs: { valign: "top" },
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "本人已认真填写并检查以上材料，保证内容真实有效。"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "tips2" }, [
                              _vm._v("课程负责人（签字）："),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "tips3" }, [
                              _vm._v("年"),
                              _c("span", [_vm._v("月")]),
                              _vm._v("日"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comTit3" }, [
                      _vm._v("7．学校政策支持及推荐意见"),
                    ]),
                    _vm._v(" "),
                    _c("table", { attrs: { border: "1" } }, [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "comText text textarea3",
                            attrs: { valign: "top" },
                          },
                          [
                            _c(
                              "p",
                              { staticStyle: { margin: "200px 50px 0 600px" } },
                              [_vm._v("(公章)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "tips2",
                                staticStyle: { "margin-top": "50px" },
                              },
                              [_vm._v("负责人（签字）：")]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "tips3" }, [
                              _vm._v("年"),
                              _c("span", [_vm._v("月")]),
                              _vm._v("日"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.isDown
                    ? _c("div", { staticClass: "shuiyin" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/img/shuiyin.png"),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "comTit3" }, [
                    _vm._v("8.学校政治审查意见"),
                  ]),
                  _vm._v(" "),
                  _c("table", { attrs: { border: "1" } }, [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "comText text textarea3",
                          attrs: { valign: "top" },
                        },
                        [
                          _c("p", { staticStyle: { "text-indent": "40px" } }, [
                            _vm._v(
                              "该课程内容及上传的申报材料无危害国家安全、涉密及其他不适宜公开传播的内容，思想导向正确，不存在思想性问题。"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "text-indent": "40px" } }, [
                            _vm._v(
                              "该课程团队负责人及成员遵纪守法，无违法违纪行为，不存在师德师风问题、学术不端等问题，五年内未出现过重大教学事故。"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "tips2" }, [
                            _vm._v("学校党委（盖章）"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "tips3" }, [
                            _vm._v("年"),
                            _c("span", [_vm._v("月")]),
                            _vm._v("日"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("i", { staticClass: "el-icon-loading" }),
      _vm._v("\n      PDF文件正在生成中......\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }